<template>
  <div class="order">
    <search
      status="14"
      :recordsSearchObj="recordsSearchObj"
      :carTypeList="carTypeList"
      @handleSearch="handleSearch"
      type="settlement"
    />
    <div class="table-container">
      <div class="table-btn">
        <el-button
          type="text"
          icon="el-icon-coin"
          @click="handleBatchConfirm()"
          :loading="btnLoading"
        >结算</el-button
        >
      </div>
      <el-table
        :data="tableData"
        border
        stripe
        v-loading="loading"
        @filter-change="filterChange"
        @selection-change="handleSelectionChange"

      >
        <el-table-column type="selection" width="40" align="center" :selectable="selectable">
        </el-table-column>
        <el-table-column type="index" label="序号" width="50" align="center">
        </el-table-column>
        <el-table-column
          prop="claimStatementId"
          label="索赔单号"
          min-width="120"
          show-overflow-tooltip
          align="center"
        >
        </el-table-column>

        <el-table-column
          prop="customerAccountNum"
          label="客户账号"
          min-width="100"
          show-overflow-tooltip
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="customerCountry"
          label="国家"
          min-width="120"
          show-overflow-tooltip
          column-key="customerCountry"
          :filters="this.countryList"
          :filter-method="filterHandler"
        >
          <template slot-scope="scope">
            <p>{{ getCountry(scope.row.customerCountry) }}</p>
          </template>
        </el-table-column>
        <el-table-column
          prop="claimStatementNum"
          label="订单号"
          min-width="120"
          show-overflow-tooltip
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="claimNode"
          label="索赔节点"
          min-width="120"
          show-overflow-tooltip
          align="center"
        >
          <template slot-scope="scope">
            <div>{{scope.row.claimNode==1?'开箱':'制程'}}</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="vin"
          label="VIN"
          min-width="120"
          show-overflow-tooltip
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="repairPlanList"
          label="维修方案"
          align="center"
          min-width="160px"
        >
        </el-table-column>
        <el-table-column
          v-for="(item, index) in responsibilityPartListMaxLength"
          :key="index"
          :label="`责任方${numberToChinese(item)}`"
          min-width="160"
          show-overflow-tooltip
          align="center"
        >
          <el-table-column
            label=""
            min-width="160"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{
                scope.row.responsibilityPartList &&
                scope.row.responsibilityPartList[index]
                  ? scope.row.responsibilityPartList[index]
                    .responsibilitySupplier ||
                  scope.row.responsibilityPartList[index]
                    .responsibilityDepartment
                  : "无"
              }}
            </template>
          </el-table-column>

          <el-table-column
            label=""
            min-width="90"
            show-overflow-tooltip
            align="center"
          >
            <template slot-scope="scope">
              {{
                scope.row.responsibilityPartList &&
                scope.row.responsibilityPartList[index]
                  ? `${scope.row.responsibilityPartList[index].responsibilityRatio}%`
                  : "无"
              }}
            </template>
          </el-table-column>
          <el-table-column
            label=""
            min-width="90"
            show-overflow-tooltip
            align="center"
          >
            <template slot-scope="scope">
              {{
                scope.row.responsibilityPartList &&
                scope.row.responsibilityPartList[index]
                  ? scope.row.responsibilityPartList[index].secondDamages
                    ? `¥${scope.row.responsibilityPartList[index].secondDamages}`
                    : "无"
                  : "无"
              }}
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column
          prop="auditResultDisplay"
          label="状态"
          min-width="120"
          show-overflow-tooltip
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="totalCostOfWork"
          label="工时费"
          min-width="120"
          show-overflow-tooltip
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="freight"
          label="运费"
          min-width="120"
          show-overflow-tooltip
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="tariff"
          label="关税"
          min-width="120"
          show-overflow-tooltip
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="materialTotalCost"
          label="材料费"
          min-width="120"
          show-overflow-tooltip
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="otherTotalCost"
          label="其他费用"
          min-width="120"
          show-overflow-tooltip
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop=""
          label="一次索赔总费用"
          min-width="160"
          show-overflow-tooltip
          align="center"
        >
          <template slot-scope="scope">
            <span
              v-if="
                scope.row.responsibilityPartList &&
                  scope.row.responsibilityPartList.length > 0
              "
            >
              ¥{{
                scope.row.currency === 1
                  ? (scope.row.claimTotalCost * exchangeRate).toFixed(2)
                  : scope.row.claimTotalCost
              }}
            </span>
          </template>
        </el-table-column>
>
<!--        <el-table-column-->
<!--          prop="createTime"-->
<!--          label="申请时间"-->
<!--          min-width="200"-->
<!--          show-overflow-tooltip-->
<!--          align="center"-->
<!--        >-->
<!--        </el-table-column>-->


        <el-table-column
          prop="openBoxDate"
          label="发生日期"
          min-width="200"
          show-overflow-tooltip
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="auditPassTime"
          label="正审时间"
          min-width="200"
          show-overflow-tooltip
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="confirmTime"
          label="责任确认时间"
          min-width="200"
          show-overflow-tooltip
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="currency"
          label="结算币种"
          :min-width="$getColumnWidth('currency',tableData)"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.currency === 0 ? "CNY" : "USD" }}
          </template>
        </el-table-column>
        <el-table-column
          prop="settlementTime"
          label="结算日期"
          min-width="200"
          show-overflow-tooltip
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="settlementStaff"
          label="结算人"
          min-width="120"
          show-overflow-tooltip
          align="center"
        >
        </el-table-column>
<!--        <el-table-column-->
<!--          prop="firstDamages"-->
<!--          label="初始金额"-->
<!--          min-width="200"-->
<!--          show-overflow-tooltip-->
<!--          align="center"-->
<!--        >-->
<!--        </el-table-column>-->
<!--        <el-table-column-->
<!--          prop="secondDamages"-->
<!--          label="二次索赔金额"-->
<!--          min-width="200"-->
<!--          show-overflow-tooltip-->
<!--          align="center"-->
<!--        >-->
<!--        </el-table-column>-->
<!--        <el-table-column-->
<!--          prop="damagesDifference"-->
<!--          label="金额差"-->
<!--          min-width="200"-->
<!--          show-overflow-tooltip-->
<!--          align="center"-->
<!--        >-->
<!--        </el-table-column>-->
        <el-table-column
          label="操作"
          align="center"
          width="160px"
          fixed="right"
        >
          <template slot-scope="scope">
            <el-button size="mini" type="text" @click="toDetail(scope.row)"
              >查看</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="fenye">
        <pagination
          :total="total"
          :page.sync="page"
          :limit.sync="pageSize"
          @pagination="handlePaginationChange"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { kdsettlementDetailList,kdsettlementIds } from "@/api/seek";
import search from "@/components/claimantSearch";
import { getNations } from "@/util/getNation";
import { getSession, setStorage } from "@/util/localStor";
import { getDownloadFiles } from "@/util/downFile";
import { getDictItem, getDictValue } from "@/util/dict";
import { numberToChinese } from "@/util/index";

export default {
  components: {
    search
  },
  data() {
    const { data, pageNum, pageSize } = this.$route?.query?.searchObj
      ? JSON.parse(this.$route?.query?.searchObj)
      : {};
    return {
      searchInfo: {
        settlementId: this.$route.query?.settlementId
      },
      btnLoading:false,
      loading: false,
      tableData: [],
      page: Number(pageNum) || 1,
      pageSize: Number(pageSize) || 10,
      total: 0,
      exportLoading: false,
      recordsSearchObj: data,
      countryList: [],
      searchData: {},
      carTypeList: [],
      multipleSelection: [],
      responsibilityPartListMaxLength: 0, // 责任方列表最大长度
      exchangeRate: 1 // 汇率
    };
  },
  async mounted() {
    this.searchInfo = this.recordsSearchObj
      ? JSON.parse(JSON.stringify(this.recordsSearchObj))
      : this.searchInfo;
    Object.values(getSession("nationList")).map(item => {
      if (item.id != 0) {
        this.countryList.push({ text: item.name, value: item.id });
      }
    });
    await this.getExchangeRate();
    this.getList();
    // 获取车型
    const carTypeList = await getDictItem("carType");
    carTypeList.map(item => {
      this.carTypeList.push({ text: item.value, value: item.code });
    });
  },
  methods: {
    numberToChinese,
    selectable(row, index){
      return row.auditResultDisplay == '待结算'
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 批量确认
    async handleBatchConfirm() {
      if (!this.multipleSelection || this.multipleSelection.length === 0) {
        this.$DonMessage.warning("请选择要结算的索赔单");
        return;
      }
      this.btnLoading = true;
      try {
        const arr = []
        this.multipleSelection.map(item => {
          arr.push(item.claimStatementId);
        });
        const res = await kdsettlementIds({
          claimStatementIds:arr
          }
        );

        if (res.status === "0") {
          this.$DonMessage.success("批量结算成功");
          this.getList();
        } else {
          this.$DonMessage.error(res.message);
        }
      } catch (error) {}
      this.btnLoading = false;
    },
    // 获取汇率
    async getExchangeRate() {
      const exchangeRateDict = await getDictItem("exchangeRate");
      const exchangeRateItem = getDictValue(exchangeRateDict, "USD/CNY");
      this.exchangeRate = exchangeRateItem?.codeText || this.exchangeRate;
    },
    // 获取二赔总金额
    getDamages({ responsibilityPartList }) {
      var sum = 0;
      responsibilityPartList.map(item => {
        sum += item.secondDamages;
      });
      return sum.toFixed(2);
    },
    // 获取国家
    getCountry(data) {
      let country = getNations(data);
      return country;
    },
    // 搜索
    handleSearch(data) {
      this.searchData = JSON.parse(JSON.stringify(data));
      let obj = data;
      this.searchInfo.claimStatementId = obj.claimStatementNum;
      this.searchInfo.customerAccountNum = obj.customerAccountNum;
      this.searchInfo.customerName = obj.customerName;
      this.searchInfo.lbjzy = obj.lbjzy;
      if (
        typeof obj.countryId === "string" ||
        typeof obj.countryId === "number"
      ) {
        this.searchInfo.country =
          obj.countryId && obj.countryId != "0" ?obj.countryId : '';
      }
      if (typeof obj.carModel === "string") {
        this.searchInfo.carModel = obj.carModel ? obj.carModel : '';
      }
      this.searchInfo.carBrand = obj.carBrand;
      this.searchInfo.vin = obj.vin;
      this.searchInfo.faultPartNumber = obj.faultPartNumber;
      this.searchInfo.faultPartNameZh = obj.faultPartNameZh;
      this.searchInfo.responsibilityDepartment = obj.responsibilityDepartment;
      this.searchInfo.supplierName = obj.supplierName;
      this.page = 1;
      this.pageSize = 10;
      this.getList();
    },
    // 记录当前列表搜索条件
    recordSearchObj() {
      this.$router.replace(
        "/kd-claimant/claimSettlementDetailList?settlementId=" +
          this.$route.query.settlementId +
          "&searchObj=" +
          JSON.stringify({
            data: {
              ...this.searchInfo
            },
            pageNum: this.page,
            pageSize: this.pageSize
          })
      );
    },
    // 查看
    toDetail(data) {
      setStorage("claimantData", data);
      this.recordSearchObj();
      this.$router.push({
        path: "/kd-claimant/claimSettlementDetail",
        query: { claimantId: data.claimStatementId, operate: "查看详情" }
      });
    },
    // 分页
    handlePaginationChange(val) {
      this.page = val.page;
      this.pageSize = val.limit;
      this.getList();
    },
    // 获取列表
    async getList() {
      this.loading = true;
      let query = {
        data: {
          ...this.searchInfo
        },
        page: {
          pageNum: this.page,
          pageSize: this.pageSize
        }
      };
      const res = await kdsettlementDetailList(query);
      if (res.status == 0) {
        this.tableData = res.data.records;
        this.total = res.data.count;
        this.loading = false;
        this.responsibilityPartListMaxLength = 0;
        res.data.records.map(item => {
          if (
            item.responsibilityPartList &&
            item.responsibilityPartList.length >
              this.responsibilityPartListMaxLength
          ) {
            this.responsibilityPartListMaxLength =
              item.responsibilityPartList.length;
          }
        });
      }
      this.loading = false;
    },
    filterHandler(value, row, column) {
      const property = column["property"];
      return row[property] === value;
    },
    filterChange(value) {
      // 国家过滤
      if (value.customerCountry) {
        if (value.customerCountry.length === 0) {
          this.searchInfo.countryId = this.searchData.countryId || [];
        } else {
          this.searchInfo.countryId = value.customerCountry;
        }
      }
      // 车型过滤
      if (value.carModel) {
        if (value.carModel.length === 0) {
          this.searchInfo.carModel = this.searchData.carModel || [];
        } else {
          this.searchInfo.carModel = value.carModel;
        }
      }
      this.getList();
    }
  }
};
</script>
<style src="@/assets/css/qualityStyle.css"></style>

<style lang="scss" scoped>
.responsibilityPartListTip {
  display: flex;
  text-align: center;
  padding: 18px 20px;
  .item {
    width: 120px;
  }
  .item2 {
    width: 180px;
  }
}
</style>
